import { LocDefs, LocMap } from '@cm/core/localization';
import {
	ncarbSchedulingPathStart,
	ncarbSchedulingSharedProperties,
} from '../ncarb-scheduling/ncarb-scheduling.locs';

export type SPCandidateHistorySchedulingNcarbAuthHistoryLocNames =
	| 'SPCandidateHistorySchedulingNcarbAuthHistorySectionTitle'
	| 'SPCandidateHistorySchedulingNcarbAuthHistoryColumnExamName'
	| 'SPCandidateHistorySchedulingNcarbAuthHistoryColumnTestDate'
	| 'SPCandidateHistorySchedulingNcarbAuthHistoryColumnState'
	| 'SPCandidateHistorySchedulingNcarbAuthHistoryColumnRegistration'
	| 'SPCandidateHistorySchedulingNcarbAuthHistoryColumnEligibilityId'
	| 'SPCandidateHistorySchedulingNcarbAuthHistoryColumnStartDate'
	| 'SPCandidateHistorySchedulingNcarbAuthHistoryColumnEndDate'
	| 'SPCandidateHistorySchedulingNcarbAuthHistoryExportFilename';

export const spCandidateHistorySchedulingNcarbAuthHistoryLocs: LocDefs<SPCandidateHistorySchedulingNcarbAuthHistoryLocNames> =
	{
		SPCandidateHistorySchedulingNcarbAuthHistorySectionTitle: {
			defaultValue: 'Authorization History',
			description: 'Section title for the authorization history section.',
			displayPath: `${ncarbSchedulingPathStart}Authorization History|Section Title`,
			displayType: 'Title',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbAuthHistoryColumnExamName: {
			defaultValue: 'Exam',
			description: 'Column header for the exam name column.',
			displayPath: `${ncarbSchedulingPathStart}Authorization History|Exam Name Column`,
			displayType: 'Label',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbAuthHistoryColumnTestDate: {
			defaultValue: 'Test Date',
			description: 'Column header for the test date column.',
			displayPath: `${ncarbSchedulingPathStart}Authorization History|Test Date Column`,
			displayType: 'Label',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbAuthHistoryColumnState: {
			defaultValue: 'State',
			description: 'Column header for the state column.',
			displayPath: `${ncarbSchedulingPathStart}Authorization History|State Column`,
			displayType: 'Label',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbAuthHistoryColumnRegistration: {
			defaultValue: 'Registration',
			description: 'Column header for the registration column.',
			displayPath: `${ncarbSchedulingPathStart}Authorization History|Registration Column`,
			displayType: 'Label',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbAuthHistoryColumnEligibilityId: {
			defaultValue: 'Eligibility ID Number',
			description: 'Column header for the eligibility ID column.',
			displayPath: `${ncarbSchedulingPathStart}Authorization History|Eligibility ID Column`,
			displayType: 'Label',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbAuthHistoryColumnStartDate: {
			defaultValue: 'Start Date',
			description: 'Column header for the start date column.',
			displayPath: `${ncarbSchedulingPathStart}Authorization History|Start Date Column`,
			displayType: 'Label',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbAuthHistoryColumnEndDate: {
			defaultValue: 'End Date',
			description: 'Column header for the end date column.',
			displayPath: `${ncarbSchedulingPathStart}Authorization History|End Date Column`,
			displayType: 'Label',
			...ncarbSchedulingSharedProperties,
		},
		SPCandidateHistorySchedulingNcarbAuthHistoryExportFilename: {
			defaultValue: 'Exam Authorization History',
			description: 'Export filename for the exam authorization history.',
			displayPath: `${ncarbSchedulingPathStart}Authorization History|Export Filename`,
			displayType: 'Title',
			...ncarbSchedulingSharedProperties,
		},
	};

export type SPCandidateHistorySchedulingNcarbAuthHistoryLocType =
	LocMap<SPCandidateHistorySchedulingNcarbAuthHistoryLocNames>;
